<div class="profile-container payment-container">
  <div class="column-0">
    <div class="settings-section selections">
      <!-- *ngIf="bankAccounts?.length > 0" -->
      <label class="section-label"
        >{{ 'labels.bankAccounts' | translate }}
        <span class="section-badge">{{ bankAccounts.length }}</span></label
      >

      @if(this.delayDisplaying) {
      <div class="empty-placeholder-loader"></div>
      } @else if(!bankAccounts?.length && !this.delayDisplaying) {
      <ops-settings-add-button
        fullWidth="true"
        [isDisabled]="isDisabledForRole"
        [label]="'labels.addBankAccount' | translate"
        (clicked)="addAdditionalBankAccount($event)"
      ></ops-settings-add-button>
      } @else if(!this.delayDisplaying) {
      <ops-select
        [options]="bankAccounts"
        showSearch="true"
        [isDisabled]="!bankAccounts?.length"
        [defaultSelected]="bankAccountSelected"
        [formName]="bankAccountSelected"
        (changed)="onSelectChange($event, 'bankAccount')"
      ></ops-select>
      }

      <div class="section-delimiter"></div>
      <label class="section-label">{{
        'labels.bankAccountDetails' | translate
      }}</label>
      <div class="profile-form">
        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.shortName' | translate"
          (validationError)="onErrorHandler($event, 'BankAccount:shortName')"
          [isDisabled]="!bankAccounts?.length"
          formName="bankAccount.shortName"
          [value]="bankAccount.shortName"
          mandatory="true"
          (changed)="onValueChange($event, 'shortName')"
          type="text"
        ></ops-input>

        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.description' | translate"
          [isDisabled]="!bankAccounts?.length"
          formName="bankAccount.description"
          [value]="bankAccount.description"
          mandatory="true"
          (validationError)="onErrorHandler($event, 'BankAccount:description')"
          (changed)="onValueChange($event, 'description')"
          type="text"
        ></ops-input>

        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.bank' | translate"
          [isDisabled]="!bankAccounts?.length"
          formName="bankAccount.bankName"
          [value]="bankAccount.bankName"
          mandatory="true"
          (validationError)="onErrorHandler($event, 'BankAccount:bankName')"
          (changed)="onValueChange($event, 'bankName')"
          type="text"
        ></ops-input>

        <ops-input
          [label]="'labels.address' | translate"
          [isPreview]="isPreview"
          [isDisabled]="!bankAccounts?.length"
          mandatory="true"
          formName="bankAccount.address"
          [value]="bankAccount.address"
          (changed)="onValueChange($event, 'address')"
          (validationError)="onErrorHandler($event, 'BankAccount:address')"
          type="text"
        ></ops-input>

        <ops-calendar
          [label]="'labels.startDate' | translate"
          [isPreview]="isPreview"
          [isDisabled]="!bankAccounts?.length"
          mandatory="true"
          (dateChanged)="onValueChange($event, 'startDate')"
          formName="bankAccount.startDate"
          [date]="bankAccount.startDate"
        ></ops-calendar>

        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.bankBranchNo' | translate"
          mandatory="true"
          [isDisabled]="!bankAccounts?.length"
          formName="bankAccount.branchName"
          [value]="bankAccount.branchName"
          (validationError)="onErrorHandler($event, 'BankAccount:branchName')"
          (changed)="onValueChange($event, 'branchName')"
          type="text"
        ></ops-input>

        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.bankSwift' | translate"
          [isDisabled]="!bankAccounts?.length"
          formName="bankAccount.SWIFT"
          mandatory="true"
          [value]="bankAccount.SWIFT"
          (validationError)="onErrorHandler($event, 'BankAccount:SWIFT')"
          (changed)="onValueChange($event, 'SWIFT')"
          type="text"
        ></ops-input>

        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.accountNumberIban' | translate"
          formName="bankAccount.IBAN"
          [value]="bankAccount.IBAN"
          mandatory="true"
          (validationError)="onErrorHandler($event, 'BankAccount:IBAN')"
          [isDisabled]="!bankAccounts?.length"
          (changed)="onValueChange($event, 'IBAN')"
          type="number"
        ></ops-input>

        <ops-select
          rotateDropdownDirection="'true'"
          [isPreview]="isPreview"
          [options]="mainCurrencies"
          [defaultSelected]="bankAccount.currencyCode"
          [formName]="bankAccount.currencyCode"
          [isDisabled]="!bankAccounts?.length"
          mandatory="true"
          [label]="'labels.currencyCode' | translate"
          (changed)="onSelectChangeForBA($event, 'currencyCode')"
        ></ops-select>

        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.correspondentBank' | translate"
          [isDisabled]="!bankAccounts?.length"
          formName="bankAccount.correspondentBank"
          [value]="bankAccount.correspondentBank"
          (validationError)="
            onErrorHandler($event, 'BankAccount:correspondentBank')
          "
          (changed)="onValueChange($event, 'correspondentBank')"
          type="text"
        ></ops-input>
        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.correspondentBankSwift' | translate"
          [isDisabled]="!bankAccounts?.length"
          formName="bankAccount.correspondentSWIFT"
          [value]="bankAccount.correspondentSWIFT"
          (validationError)="
            onErrorHandler($event, 'BankAccount:correspondentSWIFT')
          "
          (changed)="onValueChange($event, 'correspondentSWIFT')"
          type="text"
        ></ops-input>

        <ops-calendar
          invertDirection="true"
          [label]="'labels.accountBalanceStartDate' | translate"
          (dateChanged)="onValueChange($event, 'startingBalanceDate')"
          [isPreview]="isPreview"
          [isDisabled]="!bankAccounts?.length"
          formName="bankAccount.startingBalanceDate"
          [date]="bankAccount.startingBalanceDate"
        ></ops-calendar>

        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.accountBalanceStartAmount' | translate"
          [isDisabled]="!bankAccounts?.length"
          formName="bankAccount.startingBalance"
          [value]="bankAccount.startingBalance"
          (validationError)="
            onErrorHandler($event, 'BankAccount:startingBalance')
          "
          (changed)="onValueChange($event, 'startingBalance')"
          decimalValue="true"
          type="text"
        ></ops-input>

        <ops-checkbox
          [label]="'labels.isFavorite' | translate"
          [isPreview]="isPreview"
          [isDisabled]="!bankAccounts?.length"
          [formName]="bankAccount.isFavorite"
          mandatory="true"
          [value]="bankAccount.isFavorite"
          (changed)="onValueChange($event, 'isFavorite')"
        ></ops-checkbox>
      </div>
    </div>
    @if(bankAccounts?.length>0 && isPreview) {
    <ops-settings-add-button
      [isDisabled]="isDisabledForRole"
      [label]="'labels.addAdditionalBankAccount' | translate"
      (clicked)="addAdditionalBankAccount($event)"
    ></ops-settings-add-button>
    }
  </div>

  <div class="column-1">
    <div class="settings-section selections">
      <!-- *ngIf="creditCards?.length > 0" -->
      <label class="section-label">
        {{ 'labels.creditCards' | translate }}
        <span class="section-badge">{{ creditCards.length }}</span>
      </label>

      @if(this.delayDisplayingCards) {
      <div class="empty-placeholder-loader"></div>
      } @else if(!creditCards?.length && !this.delayDisplayingCards) {
      <ops-settings-add-button
        [isDisabled]="!bankAccounts?.length || isDisabledForRole"
        fullWidth="true"
        [label]="'labels.addCreditCard' | translate"
        (clicked)="addAdditionalCreditCard($event)"
      ></ops-settings-add-button>
      } @else if(!this.delayDisplayingCards) {
      <ops-select
        [options]="creditCards"
        showSearch="true"
        [isDisabled]="!creditCards?.length"
        [defaultSelected]="creditCardSelected"
        [formName]="creditCardSelected"
        (changed)="onSelectCCChange($event, 'bankAccount')"
      ></ops-select>
      }

      <div class="section-delimiter"></div>
      <label class="section-label">{{
        'labels.creditCardDetails' | translate
      }}</label>
      <div class="profile-form">
        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.shortName' | translate"
          [isDisabled]="!creditCards?.length"
          formName="creditCard.shortName"
          [value]="creditCard.shortName"
          mandatory="true"
          (changed)="onValueChangeC($event, 'shortName')"
          (validationError)="onErrorHandler($event, 'CreditCard:shortName')"
          type="text"
        ></ops-input>

        <ops-input
          [isPreview]="isPreview"
          [label]="'labels.description' | translate"
          [isDisabled]="!creditCards?.length"
          formName="creditCard.description"
          [value]="creditCard.description"
          mandatory="true"
          (changed)="onValueChangeC($event, 'description')"
          (validationError)="onErrorHandler($event, 'CreditCard:description')"
          type="text"
        ></ops-input>

        <ops-input-preview
          [isPreview]="isPreview"
          [label]="'labels.connectedBankAccount' | translate"
          [isDisabled]="!creditCards?.length"
          [value]="creditCardBank"
          type="text"
        ></ops-input-preview>

        <ops-select
          [options]="cutOffDays"
          [isPreview]="isPreview"
          [isDisabled]="!bankAccounts?.length"
          [defaultSelected]="creditCard.cutOffDateDay"
          [formName]="creditCard.cutOffDateDay"
          [label]="'labels.cutOffDate' | translate"
          mandatory="true"
          (changed)="onSelectChangeForCCOpt($event, 'cutOffDateDay')"
        ></ops-select>

        <ops-select
          [options]="cutOffDays"
          [isPreview]="isPreview"
          showSearch="true"
          [isDisabled]="!bankAccounts?.length"
          [defaultSelected]="creditCard.settlementDateDay"
          formName="creditCard.settlementDateDay"
          [label]="'labels.settlementDate' | translate"
          mandatory="true"
          (changed)="onSelectChangeForCCOpt($event, 'settlementDateDay')"
        ></ops-select>

        <ops-input-preview
          [isPreview]="isPreview"
          [label]="'labels.billingPeriod' | translate"
          [isDisabled]="!creditCards?.length"
          [textOnly]="true"
          [value]="creditCardBillingPeriod"
          type="text"
        ></ops-input-preview>

        <ops-select
          [isPreview]="isPreview"
          [isDisabled]="!creditCards?.length"
          rotateDropdownDirection="'true'"
          [options]="mainCurrencies"
          mandatory="true"
          [defaultSelected]="creditCard.currencyCode"
          [formName]="creditCard.currencyCode"
          [label]="'labels.currencyCode' | translate"
          mandatory="true"
          (changed)="onValueChangeC($event, 'currencyCode')"
        ></ops-select>

        <ops-checkbox
          [label]="'labels.isFavorite' | translate"
          [isPreview]="isPreview"
          [isDisabled]="!creditCards?.length"
          [formName]="creditCard.isFavorite"
          [value]="creditCard.isFavorite"
          mandatory="true"
          (changed)="onValueChangeC($event, 'isFavorite')"
        ></ops-checkbox>

        <div class="nfut-container">
          <ops-calendar
            invertDirection="true"
            [label]="'labels.validUntil' | translate"
            [isDisabled]="!creditCards?.length"
            (dateChanged)="onValueChangeC($event, 'expirationDate')"
            [isPreview]="isPreview"
            formName="creditCard.expirationDate"
            [minDate]="minExpirationDate"
            [maxDate]="maxExpirationDate"
            mandatory="true"
            [date]="creditCard.expirationDate"
          ></ops-calendar>

          <ops-input
            [isPreview]="isPreview"
            placeholder="1234"
            [isDisabled]="!creditCards?.length"
            [label]="'labels.lastFourDigits' | translate"
            formName="creditCard.lastFourDigits"
            [value]="creditCard.lastFourDigits"
            (changed)="onValueChangeC($event, 'lastFourDigits')"
            (validationError)="
              onErrorHandler($event, 'CreditCard:lastFourDigits')
            "
            mandatory="true"
            type="last4digits"
          ></ops-input>
        </div>
      </div>
    </div>
    @if(bankAccounts?.length>0 && creditCards?.length>0 && isPreview) {
    <ops-settings-add-button
      [isDisabled]="isDisabledForRole"
      [label]="'labels.addAdditionalCreditCard' | translate"
      (clicked)="addAdditionalCreditCard($event)"
    ></ops-settings-add-button>
    }
  </div>

  <div class="column-1">
    <div class="settings-section payment-accounts comming-soon">
      <label class="section-label"
        ><span>{{ 'labels.paypalAccount' | translate }}</span>
        <div *ngIf="!isPreview" class="comming-soon">
          {{ 'labels.comingSoon' | translate }}
        </div></label
      >
      <div class="profile-form">
        <ops-input
          [isPreview]="isPreview"
          isDisabled="true"
          [label]="'labels.emailAccount' | translate"
          formName="paypalAccount"
          [value]="paypalAccount"
          (changed)="onValueChange($event, 'paypalAccount')"
          type="email"
        ></ops-input>
      </div>
    </div>
    <!-- <div class="settings-section">
      <label class="section-label">Wise Account</label>
      <div class="profile-form">
        <ops-input
          [isPreview]="isPreview"
          label="Email / Account"
          formName="wiseAccount"
          [value]="wiseAccount"
          (changed)="onValueChange($event, 'wiseAccount')"
          type="email"
        ></ops-input>
      </div>
    </div> -->
    <div class="settings-section payment-accounts comming-soon">
      <label class="section-label"
        ><span>{{ 'labels.venmoAccount' | translate }}</span>
        <div *ngIf="!isPreview" class="comming-soon">
          {{ 'labels.comingSoon' | translate }}
        </div></label
      >
      <div class="profile-form">
        <ops-input
          [isPreview]="isPreview"
          isDisabled="true"
          [label]="'labels.emailAccount' | translate"
          formName="venmoAccount"
          [value]="venmoAccount"
          (changed)="onValueChange($event, 'venmoAccount')"
          type="email"
        ></ops-input>
      </div>
    </div>

    <!-- <ops-settings-add-button
      *ngIf="!isPreview"
      label="+ Add Digital Payment Service"
      (clicked)="addDigitalPaymentService($event)"
    ></ops-settings-add-button> -->
  </div>
</div>

@if(addingNewBankAccount) {
<ops-bank-account-create (closeModal)="cancelAddingBankAccount($event)" />
} @if(addingNewCreditCard) {
<ops-credit-card-create (closeModal)="cancelAddingCreditCard($event)" />
}
